export function StartScreen({ numOfQuestions, dispatch }) {
  return (
    <div className='start'>
      <h2>Welcome to the React Quiz</h2>
      <h3>{numOfQuestions} questions to test your React mastery</h3>
      <button
        className='btn btn-ui'
        onClick={() => dispatch({ type: 'START_GAME' })}
      >
        Lets Start
      </button>
    </div>
  );
}
